// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const futuretvColors: ColorType = {
  ...colorPalette,
  primary: '#E92E53',
  secondary: '#E92E53',
  grayText: '#B0B0B0',
  grayLabel: '#717171',
  grayBorder: 'rgba(255, 255, 255, 0.38)',
}

export const darkTheme = {
  colors: futuretvColors,
  background: {
    primary: '#181818',
    secondary: '#262626',
    highlight: futuretvColors.dark,
    select: '#2e2e2e',
    footerTop: '#333',
  },
  text: {
    primary: futuretvColors.primaryGray,
    secondary: futuretvColors.secondaryGray,
    disabled: futuretvColors.grayText,
    link: futuretvColors.secondaryGray,
    hint: futuretvColors.white,
    highlight: futuretvColors.secondary,
    gray: futuretvColors.primaryGray,
    seeAll: futuretvColors.secondaryGray,
    primaryContrast: '#ffffff',
  },
  border: {
    primary: futuretvColors.primaryGray,
    gray: futuretvColors.secondaryGray,
  },
  filter: {
    primary: futuretvColors.primaryGray,
    secondary: futuretvColors.secondaryGray,
    disabled: futuretvColors.secondaryGray,
    highlight: '#111111',
  },
  tabs: {
    bg: '#181818',
    containerBg: futuretvColors.dark,
    color: futuretvColors.white,
    border: futuretvColors.primary,
    scrollbarThumb: '#bdbdbd',
    programTitle: futuretvColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: '#2e2e2e',
        hover: futuretvColors.dark,
        selected: futuretvColors.dark,
        progress: rgba(futuretvColors.primary, 0.3),
        past: rgba(futuretvColors.primary, 0.3),
        pastSelected: futuretvColors.dark,
        pastHover: futuretvColors.dark,
        empty: '#555555',
        emptyProgress: rgba(futuretvColors.primary, 0.2),
      },
      text: {
        empty: futuretvColors.secondaryGray,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #181818 0%,${rgba('#181818', 0.97)} 13.03%,${rgba('#181818', 0.69)} 43.24%,${rgba(
          '#181818',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0, #181818 0%,${rgba('#181818', 0.73)} 34.97%,${rgba('#181818', 0)} 100%);`,
    },
  },
  card: {
    title: futuretvColors.white,
    subTitle: futuretvColors.secondaryGray,
    bg: futuretvColors.grayText,
    number: '#DFDFDF',
    boxShadow: '#2e2e2e',
    loaderBackgroundImage: 'linear-gradient(to right, #222 0%, #111 20%, #222 40%, #222 100%)',
  },
  dimension: {
    fullBGImage: true,
    fullBGImageSize: 'cover',
    signBGColor: '#252525',
    signLogoSize: 312,
  },
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
